import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext } from 'styled-components';
import { env } from '../../../../docs/utils/docs.config';

import CircleWithPerson from '../../../../foundations/Icon/icons/utility/CircleWithPerson';

import {
  DivStyled,
  LinkStyledLogin,
  LinkStyledLoginFwm,
} from './styles';

export const UserLoginButtonComponent = ({
  isFwm = false,
  variant = '',
}) => {
  const theme = useContext(ThemeContext);
  const largeUp = theme.largeUp();
  const useFwmLoginLink = variant === 'fwm' || isFwm;

  const thisAriaLabel = 'Log into your Northwestern Mutual account';
  const thisLoginLinkUrl = env.services.loginPageUrl;

  return (
    <>
      {useFwmLoginLink ? (
        <LinkStyledLoginFwm
          aria-label={thisAriaLabel}
          id='fwm-login-link'
          linkUrl={thisLoginLinkUrl}
          startAdornment={CircleWithPerson}
          startAdornmentStylesReset
          themeType='darkTheme'
          variant='buttonLinkTertiary'
        >
          Client Login
        </LinkStyledLoginFwm>
      ) : (
        <DivStyled className='nm-login-button'>
          <LinkStyledLogin
            aria-label={thisAriaLabel}
            className='nmx-nav-link nmx-nav-link-utility'
            id='nmx-login-link'
            linkUrl={thisLoginLinkUrl}
            startAdornment={largeUp ? CircleWithPerson : null}
            startAdornmentStylesReset
            themeType='darkTheme'
            variant='buttonLinkTertiary'
          >
            Log in
          </LinkStyledLogin>
        </DivStyled>
      )}
    </>
  );
};

UserLoginButtonComponent.propTypes = {
  /** Optional prop to render FWM login button variant */
  isFwm: PropTypes.bool,
  variant: PropTypes.oneOf(['fwm']),
};

export default UserLoginButtonComponent;
